<template>
  <v-btn tile outlined class="filterButton d-flex justify-space-between">
    <span class="buttonText">FILTRO</span>
    <Icon size="24" icon="mdi-filter-outline" color="#0012A6" />
  </v-btn>
</template>

<script>
import Icon from "@/components/atoms/icon";

export default {
  components: { Icon }
};
</script>

<style scoped>
.filterButton {
  border: 1px solid #0439d9;
  box-sizing: border-box;
  border-radius: 5px;
  width: 163px;
  height: 40px;
}

.buttonText {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.16px;
  text-transform: uppercase;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #0012a6;
}
</style>